import React from 'react';
import { Box, Card, IconButton, Typography, styled } from '@mui/material';
import { radius } from 'themes/radius';
import EditIcon from '@mui/icons-material/Edit';

export type HealthGoalCardProps = {
  title: string;
  icon: React.ReactNode;
  /** Shows the edit button when provided. */
  onEdit?: () => void;
};

const ILLUSTRATION_WIDTH = 64;

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 2),
  borderRadius: radius.card,
  backgroundColor: theme.palette.background.paper,
  boxShadow: `0 1px 2px 0 ${theme.palette.grey[400]}`,
}));

const IllustrationContainer = styled(Box)({
  width: ILLUSTRATION_WIDTH,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > svg': {
    width: '100%',
    height: 'auto',
  },
});

const Title = styled(Typography)(({ theme }) => ({
  flex: 1,
  color: theme.palette.grey[800],
  overflowWrap: 'anywhere',
}));

const EditButton = styled(IconButton)(({ theme }) => ({
  flexShrink: 0,
  marginLeft: 'auto',
  color: theme.palette.primary.main,
}));

export const HealthGoalCard: React.FC<HealthGoalCardProps> = ({ title, icon, onEdit }) => (
  <StyledCard className="health-goal-card" elevation={0}>
    <IllustrationContainer className="health-goal-card__icon">{icon}</IllustrationContainer>

    <Title className="health-goal-card__title" variant="callout" fontWeight="medium">
      {title}
    </Title>

    {onEdit && (
      <EditButton className="health-goal-card__edit" onClick={onEdit} aria-label={`Edit ${title}`}>
        <EditIcon fontSize="small" />
      </EditButton>
    )}
  </StyledCard>
);
